var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.40624 0.631753C8.46373 0.63165 8.52068 0.64288 8.57383 0.6648C8.62697 0.68672 8.67528 0.718901 8.71599 0.759503L13.0472 5.09075C13.1293 5.1728 13.1753 5.28406 13.1753 5.40007C13.1753 5.51608 13.1293 5.62733 13.0472 5.70938C12.6272 6.12938 12.1092 6.22388 11.7321 6.22388C11.5772 6.22388 11.439 6.20813 11.3296 6.18975L8.58736 8.932C8.65955 9.22286 8.70639 9.51943 8.72736 9.81838C8.76761 10.4326 8.69936 11.2945 8.09736 11.8965C8.01532 11.9785 7.90406 12.0246 7.78805 12.0246C7.67204 12.0246 7.56078 11.9785 7.47874 11.8965L5.00336 9.422L2.21911 12.2063C2.04849 12.3769 1.15249 12.9955 0.981861 12.8249C0.811236 12.6543 1.42986 11.7574 1.60049 11.5876L4.38474 8.80338L1.91024 6.328C1.82822 6.24596 1.78214 6.1347 1.78214 6.01869C1.78214 5.90268 1.82822 5.79142 1.91024 5.70938C2.51224 5.10738 3.37411 5.03825 3.98836 5.07938C4.28731 5.10033 4.58388 5.14717 4.87474 5.21938L7.61699 2.478C7.5941 2.34476 7.58239 2.20983 7.58199 2.07463C7.58199 1.69838 7.67649 1.18038 8.09736 0.759503C8.17935 0.677717 8.29043 0.631777 8.40624 0.631753Z",
    fill: "#1E293B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinActive);
export default __webpack_public_path__ + "static/media/pinActive.d44ee91c86b577250c75389d9d034fc6.svg";
export { ForwardRef as ReactComponent };